<script lang="ts">
  import Search from "$lib/ui/form/Search.svelte";
  import { RxWritable } from "$lib/util/obs";
  import { debounceTime, tap } from "rxjs";
  import { query } from "$lib/util/url";
  import { showDetail } from "./Main.svelte";

  export let errorCode = 0;

  const search$ = new RxWritable("");
  const search$$ = search$.pipe(
    debounceTime(1000),
    tap(async (s) => {
      if (!s) return;

      const { search } = window.location;
      await query(search).set("search", s).go();
      showDetail(null);
    })
  );
  $search$$;
</script>

<div id="container" class="flex-column align-center justify-center">
  {#if errorCode === 400}
    <div class="mb">Bad catalogue key</div>
  {:else if errorCode === 404}
    <div class="mb">Product not found</div>
  {:else}
    <div class="mb">Whoops! Something has gone south. Way south...</div>
  {/if}
  <div class="mb">Try searching for the product...</div>
  <Search bind:value={$search$} placeholder="Search products" />
</div>

<style lang="scss">
  #container {
    min-height: 650px;
  }

  .mb {
    margin-bottom: 16px;
  }
</style>
